import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import classNames from 'classnames'

import { ErrorHandler } from './PublicErrorHandler'

import { Footer } from 'components'
import { PublicPageNavbar } from 'components/Navbar/PublicPageNavbar'

export const PublicLayout: React.FC = () => {
  return (
    <>
      <PublicPageNavbar />

      <div className="flex w-full min-h-screen pb-l">
        <div className="hidden min-tablet:block w-1/2 bg-login-bg bg-cover bg-right-bottom bg-header-bg-color" />

        <div className="flex justify-center items-center w-full px-3 min-tablet:py-6 min-tablet:w-1/2">
          <div
            className={classNames([
              'flex items-center bg-white w-full shadow-as',
              'phone:h-full min-tablet:rounded-xl min-tablet:w-[350px]',
            ])}
          >
            <div className="px-5 w-full gap-5 phone:mt-xl min-tablet:py-10">
              <div className="flex flex-col items-center gap-3 mb-12">
                <img
                  className="h-[3.75rem]"
                  src="/images/login-modal-logo.svg"
                  alt="logo"
                />
              </div>

              <Suspense fallback={null}>
                <ErrorHandler>
                  <Outlet />
                </ErrorHandler>
              </Suspense>
            </div>
          </div>
        </div>
      </div>

      <Footer className="-mt-l" layout="public" />
    </>
  )
}
